// extracted by mini-css-extract-plugin
module.exports = {"modal":"aJ20pzMw","form":"__9uflEvxi","radio":"__1KGu1H7R","input":"O2T_YZgg","desc":"_wBkmq0q","footer":"__5rmdSKOX","button":"xKuAMIvS"};